var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsFilterOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#DB536A;}\r\n\t.st2{fill:#E0301E;}\r\n\t.st3{fill:#D04A02;}\r\n\t.st4{fill:#464646;}\r\n\t.st5{fill:#7D7D7D;}\r\n\t.st6{fill:#2D2D2D;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2_8_",
    d: "M16,13.5v18L38.5,45l1.8,15.8l0.5,4.5L43,85.5h18l2.3-20.3l0.5-4.5L65.5,45L88,31.5v-18H16z M20.5,29V18 h63v11L83,29.3H21L20.5,29z M43,44.5l-0.2-2.2l-1.9-1.1l-12.3-7.4h47l-12.3,7.4l-1.9,1.1L61,44.5l-1.8,16.2H44.8L43,44.5z  M45.3,65.3h13.4L57,81H47L45.3,65.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsFilterOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Filter_Outline_Black_RGB.47820fad664a7e299864350f4ef1b57f.svg";
export { ForwardRef as ReactComponent };